<template>
  <a>
    <br/>
    <span class="modal-body-text">You are submitting {{ (itemName == 'all event') ? '' : 'event '}} <span
      class="modal-event-name">{{ (itemName == 'all event') ? 'all event' : (itemName)}}</span> for approval.</span><br/><br/>
      <div v-if="!showCustomMessage">
        <span class="modal-body-text">By submitting this event to ADURO you are agreeing all of the information is accurate
    and if approved, ADURO will schedule the event.</span><br/><br/>
        <span class="modal-body-text">If the event is not approved, ADURO will send the event with changes or suggestions
    back to you.</span>
      </div>
      <div v-else v-html="customMessage" class="custom-message modal-body-text"></div>
<br/><br/>
  </a>
</template>

<script>
// import consts from '../../_consts';
import {mapGetters} from 'vuex';
export default {
  name: 'submit-event-body-modal',
  props: {
    itemName: {
      type: String,
      default: ''
    }
  },
  computed: {
    showCustomMessage () {
      let message = this.getMessage;
      return message !== '' && message !== null;
    },
    customMessage () {
      return this.getMessage;
    },
    ...mapGetters({
      getMessage: 'GETTER_GET_SUBMISSION_MESSAGE'
    })
  }
}
</script>
<style lang="less">
@import '../../styles/variables.less';
.modal-event-name{
  font-weight: 600;
  color: @blue;
}
.custom-message{
  max-height: 300px;
  // overflow-x: hidden;
  overflow-y: auto;
}
// .custom-message::-webkit-scrollbar { 
//     display: none; 
// }
</style>



// WEBPACK FOOTER //
// SubmitEventModal.vue?3f1f4022